import type { UserRole } from '@/types/auth'

export type Permission =
  // Customers
  | 'customers:read'
  | 'customers:create'
  | 'customers:update'
  | 'customers:delete'
  // Sales
  | 'sales:read'
  | 'sales:create'
  | 'sales:update'
  | 'sales:delete'
  // Appointments
  | 'appointments:read'
  | 'appointments:create'
  | 'appointments:update'
  | 'appointments:delete'
  // Groups
  | 'groups:read'
  | 'groups:create'
  | 'groups:update'
  | 'groups:delete'
  // Reports
  | 'reports:read'
  | 'reports:export'
  // Financial
  | 'financial:read'
  // Admin
  | 'users:read'

// Permissões granulares por role conhecido
// Para roles não listados, retorna permissões básicas
const ROLE_PERMISSIONS: Record<string, Permission[]> = {
  vendedor: [
    'customers:read',
    'customers:create',
    'customers:update',
    'sales:read',
    'sales:create',
    'appointments:read',
    'appointments:create',
    'appointments:update',
    'appointments:delete',
    'groups:read',
  ],
  gerencia: [
    'customers:read',
    'customers:create',
    'customers:update',
    'customers:delete',
    'sales:read',
    'sales:create',
    'sales:update',
    'sales:delete',
    'appointments:read',
    'appointments:create',
    'appointments:update',
    'appointments:delete',
    'groups:read',
    'groups:create',
    'groups:update',
    'groups:delete',
    'reports:read',
    'reports:export',
    'financial:read',
    'users:read',
  ],
  contabilidade: [
    'customers:read',
    'sales:read',
    'reports:read',
    'reports:export',
    'financial:read',
  ],
}

// Permissões padrão para roles não mapeados
const DEFAULT_PERMISSIONS: Permission[] = [
  'customers:read',
  'appointments:read',
  'groups:read',
]

export function hasPermission(role: UserRole, permission: Permission): boolean {
  const permissions = ROLE_PERMISSIONS[role] ?? DEFAULT_PERMISSIONS
  return permissions.includes(permission)
}

export function getPermissions(role: UserRole): Permission[] {
  return ROLE_PERMISSIONS[role] ?? DEFAULT_PERMISSIONS
}
